const warps = {
  noWarp: {
    id: 1,
    label: 'customCheckerboardNoWarp'
  },
  bulge: {
    id: 2,
    label: 'customCheckerboardBulge',
    method: 'bulgePinch',
    combinations: [
      [512, 250, 800, 0.8]
    ]
  },
  pinch: {
    id: 3,
    label: 'customCheckerboardPinch',
    method: 'bulgePinch',
    combinations: [
      [512, 500, 600, -0.8]
    ]
  },
  crazyWarp: {
    id: 4,
    label: 'customCheckerboardCrazy',
    method: 'swirl',
    combinations: [
      [100, 100, 200, 1],
      [200, 100, 250, 1],
      [250, 200, 400, 0.3],
      [250, 300, 400, 1],
      [250, 500, 400, 1],
      [250, 700, 400, 1],
      [100, 900, 200, 1],
      [500, 100, 200, 1],
      [500, 100, 150, 1],
      [500, 200, 400, 1],
      [500, 300, 400, 1],
      [500, 500, 400, 1],
      [500, 700, 400, 1],
      [400, 900, 400, 1],
      [600, 900, 200, 1],
      [1000, 100, 400, 1],
      [800, 200, 200, 1],
      [750, 100, 400, 1],
      [750, 300, 400, 1],
      [750, 500, 400, 1],
      [750, 700, 400, 1],
      [800, 900, 150, 1],
      [850, 900, 200, 1]
    ]
  }
};

export {
  warps
};
